document.addEventListener("rebuy:smartcart.show", (event) => {
  setTimeout(() => {
    try {
      if (window?.igData) {
        window.igData.resetDom();
      }
    } catch (e) {
      // Do nothing
    }
  }, 250);
});